module.exports = __webpack_public_path__ + "img/img50.4b3accc6.png";